import React from 'react'
import { TextField } from '../fields'
import {
  StepCard,
  TitleContainer,
  StepIndicator,
  SectionTitle,
  Row,
  FieldWrapper,
} from '../styles'

const Comments = ({ values, setValue }) => (
  <StepCard>
    <TitleContainer>
      <StepIndicator>7</StepIndicator>
      <SectionTitle>Comments</SectionTitle>
    </TitleContainer>
    <Row>
      <FieldWrapper $basis="100%">
        <TextField
          fullWidth
          multiline
          minRows={4}
          label="Anything else you'd like us to know?"
          value={values.comments || ''}
          onChange={v => setValue('comments', v)}
        />
      </FieldWrapper>
    </Row>
  </StepCard>
)

export default Comments
